<template>
  <div id="app">
    <transition name="el-fade-in">
      <router-view v-if="IsRouterAlive"></router-view>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
import {getCode} from '@/config/api.js'
export default {
  name: 'app',
  provide () {
    return {
      reload:this.reload,
      goLogin:this.goLogin
    }
  },
  data () {
    return {
      style: '',
      IsRouterAlive:true,
      sDate1: this.$store.state.getTime,
    }
  },
  methods: {
    reload () {
      this.IsRouterAlive=false;
      this.$nextTick(function () {
        this.IsRouterAlive=true;
      })
    },
    goLogin () {
      let iWidth = 600;
      let iHeight = 500;
      let iTop = (window.screen.height-30-iHeight)/2;
      let iLeft = (window.screen.width-10-iWidth)/2;
      axios.get(getCode)
      .then( res => {
        window.open(res.data.url,"name", 'height='+iHeight+',,innerHeight='+iHeight+',width='+iWidth+',innerWidth='+iWidth+',top='+iTop+',left='+iLeft+',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no');
      })
    },
    dateDiff () {
      if (this.$store.state.code && this.$store.state.openid && this.sDate1) {
        let date2 = new Date();
        let date1 = new Date(Date.parse(this.sDate1.replace (/-/g,"/")));
        let iDays = parseInt(Math.abs(date2.getTime()- date1.getTime()) / 1000 / 60 / 60 / 24);
        // window.console.log(iDays);
        if (iDays >= 1) {
          this.$store.commit('changeCode' ,'');
          this.$store.commit('changeAuthToken' ,'');
          this.$store.commit('changeOpenId' ,'');
          this.$store.commit('changeUnionId' ,'');
          this.$store.commit('changeIsAuth' ,NaN);
          this.$store.commit('changeId' ,NaN);
          this.$store.commit('changeUserType' ,3);
          this.$store.commit('changeIsOperater' ,0);
          this.$store.commit('changeIsPass' ,NaN);
          this.$store.commit('changeAuthType' ,NaN);
          this.$store.commit('changeRank' ,NaN);
          this.$store.commit('changeNewbieTask' ,NaN);
          this.$store.commit('changeIsAnswer' ,NaN);
          this.$store.commit('changeIsInfo' ,NaN);
          this.$store.commit('changeWeChatNumber' ,NaN);
          this.$store.commit('changeWeChatFriendNum' ,NaN);
          this.$store.commit('changeSource' ,NaN);
          this.$store.commit('changeLabel' ,NaN);
          this.$store.commit('changeGetTime' ,NaN);
          this.$message.error('登录信息已过期，请重新登录');
          this.reload();
        }
      }
    }
  },
  mounted() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://v1.cnzz.com/z_stat.php?id=1278090778&web_id=1278090778';
    script.language = 'JavaScript';
    document.body.appendChild(script);
    this.dateDiff();
    // window.addEventListener('beforeunload',()=>{
    //   localStorage.removeItem('source');
    // });
  },
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = '/';
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }
}
</script>
<style></style>
